import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactModal from "react-modal";
import styles from "./styles.module.scss";
import { barcodeImage } from "../../../../utils/brcodeImage";
import barCodeScanner from "../../../../assets/images/Barcode-amico.svg";
import { PiListNumbersFill } from "react-icons/pi";
import { BiBarcodeReader } from "react-icons/bi";
import { BrComerceApiService } from "../../../../services/BrComerceApiService";

export const ScanModal = ({
  setLoading,
  packages,
  setPackages,
  addPackageModal,
  setAddPackageModal,
  setNewRouteShippings = undefined,
  deleteRouteShippings = undefined,
  setDeleteRouteShippings = undefined
}) => {

  const modalTypes = {
    manual: "manual",
    scanner: "scanner",
  }

  const stylesModal22 = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(51, 51, 51, 0.75)",
      zIndex: 999
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      zIndex: 999,
      border: "none",
      backgroundColor: "transparent",
      padding: 0,
      overflow: "visible"
    }
  };

  const inputRef = useRef(null);
  const bufferRef = useRef('');

  const [digitCodeModal, setDigitCodeModal] = useState(false);
  const [scannerModal, setScannerModal] = useState(false);
  const [typeModal, setTypeModal] = useState();
  const [sroOk, setSroOk] = useState("vazio");
  const [loadingSro, setLoadingSro] = useState(false);

  const [shippingCodeData, setShippingCodeData] = useState({
    code: "",
    error: "",
    isOK: "vazio",
  })

  const api = new BrComerceApiService();

  const hasJustNumbers = (str) => {
    return /^\d+$/.test(str)
  }

  const handleModal = useCallback(() => {
    if (!typeModal) {
      setDigitCodeModal(false)
      setScannerModal(false)
    } else {
      if (typeModal === modalTypes.scanner) {
        setScannerModal(true)
      } else {
        setDigitCodeModal(true)
      }
    }
    setSroOk("vazio");
    setShippingCodeData((prevData) => ({
      ...prevData,
      code: "",
    }));
  }, [modalTypes.scanner, typeModal])

  const sendRequestSRO = useCallback(async (code) => {
    const isScanner = typeModal === modalTypes.scanner;
    const isOwnCollect = hasJustNumbers(code) || (isScanner && code.includes("own_collect"));
    if (isOwnCollect) {
      if (isScanner) {
        code = code.split("-")[1]
      }

      const relations = '["user", "collectAddress"]';
      setLoading(true);
      try {
        const response = await api.makeHttpRequest({
          method: "GET",
          url: `/own-collect/add-location/${code}`,
          params: {
            relations,
          }
        });
        if (!response) {
          const message = "Coleta não encontrada";
          setShippingCodeData((prevData) => ({
            ...prevData,
            error: message,
            isOK: 'notOk'
          }));
        } else {
          setPackages((prevState) => ([response, ...prevState]));

          if (setNewRouteShippings !== undefined) {
            setNewRouteShippings((prevState) => ([...prevState, response]));
          }

          handleModal();
        }
      } catch (err) {
        console.log({ err })
        const message = err?.response?.data?.message ?? "Falha ao buscar coleta";
        setShippingCodeData((prevData) => ({
          ...prevData,
          error: message,
          isOK: 'notOk'
        }));
      } finally {
        setLoading(false);
        setLoadingSro(false);
      }

    } else {
      await api
        .makeHttpRequest({
          method: "GET",
          url: `/route-shipping-admin/bySro/${code}`,
        })
        .then(async (response) => {
          setPackages((prevState) => ([response, ...prevState]));

          if (setNewRouteShippings !== undefined) {
            setNewRouteShippings((prevState) => ([...prevState, response]));
          }

          handleModal();
        })
        .catch(err => {
          const message = err?.response?.data?.message ?? "Falha ao buscar pacote";
          setShippingCodeData((prevData) => ({
            ...prevData,
            error: message,
            isOK: 'notOk'
          }));
        })
        .finally(() => {
          setLoading(false);
          setLoadingSro(false);
        });
    }
  }, [handleModal, setLoading, setNewRouteShippings, setPackages, typeModal, packages])

  const searchShippingSro = useCallback(async () => {
    setLoading(true);

    if (!shippingCodeData.code) {
      setShippingCodeData((prevData) => ({
        ...prevData,
        error: "Código do objeto ou coleta é obrigatório",
        isOK: 'notOk'
      }));
      setLoading(false);
      setSroOk("vazio")
      return;
    }

    if (shippingCodeData.error === "notOk") {
      return;
    }

    const isOwnCollect = hasJustNumbers(shippingCodeData.code)

    let ownCollectId = isOwnCollect ? shippingCodeData.code : null;

    if (typeModal === modalTypes.scanner && ownCollectId) {
      ownCollectId = ownCollectId.split("-")[1]
    }

    ownCollectId = Number(ownCollectId);

    const shippingAlreadyExists = packages?.some((p) =>
      p.sro?.toLowerCase() === shippingCodeData.code?.toLowerCase()
      || p.name?.toLowerCase() === shippingCodeData.code?.toLowerCase()
    );
    const collectAlreadyExists = packages?.some((p) => isOwnCollect && (p?.id_own_collect === ownCollectId || p?.id === ownCollectId));

    if (shippingAlreadyExists || collectAlreadyExists) {
      setShippingCodeData((prevData) => ({
        ...prevData,
        error: "Código ou etiqueta já utilizado(a)",
        isOK: 'notOk'
      }));
      setLoading(false);
      setLoadingSro(false);
      return;
    }

    if (deleteRouteShippings !== undefined) {
      const pack = deleteRouteShippings?.find((ps) => ps?.sro === shippingCodeData.code);
      const ownCollect = deleteRouteShippings?.find((ps) => isOwnCollect && (ps?.id_own_collect === ownCollectId || ps?.id === ownCollectId));
      if (pack || ownCollect) {
        setPackages(prevState => [...prevState, isOwnCollect ? ownCollect : pack]);
        setNewRouteShippings(prevState => [...prevState, isOwnCollect ? ownCollect : pack]);
        setDeleteRouteShippings(prevState => prevState.filter((ps) => isOwnCollect ? (ps?.id_own_collect !== ownCollect?.id_own_collect || ps?.id !== ownCollectId) : (ps?.shipping?.id !== pack?.shipping?.id || ps?.id === pack?.id)));
        handleModal();
        setLoading(false);
        setLoadingSro(false);
      } else {
        await sendRequestSRO(shippingCodeData.code);
      }

    } else {
      await sendRequestSRO(shippingCodeData.code);
    }

  }, [deleteRouteShippings, handleModal, packages, sendRequestSRO, setDeleteRouteShippings, setLoading, setNewRouteShippings, setPackages, shippingCodeData.code, shippingCodeData.error]);

  const handleInputCode = useCallback(event => {
    let { name, value } = event.target;
    value = value?.trim();

    setShippingCodeData((prevData) => ({
      ...prevData,
      [name]: value,
      error: value?.length < 1 || !value ? 'Campo obrigatório' : "",
      isOK: value?.length < 1 || !value ? 'notOk' : "vazio"
    }));
  }, []);

  useEffect(() => {
    const handleKeyPress = async (event) => {
      if (scannerModal) {
        const inputElement = inputRef.current;
        if (event.key === 'Enter') {
          if (inputElement && bufferRef.current) {
            setShippingCodeData((prevData) => ({
              ...prevData,
              code: bufferRef.current,
              error: bufferRef.current?.length < 1 || !bufferRef.current ? 'Campo obrigatório' : "",
              isOK: bufferRef.current?.length < 1 || !bufferRef.current ? 'notOk' : "vazio"
            }));
            setLoadingSro(true);
            setSroOk("ok")
            bufferRef.current = '';  // Limpa o buffer
          }
        } else {
          bufferRef.current += event.key;
        }
      }
    };

    window.addEventListener('keypress', handleKeyPress);

    // Cleanup ao fechar o modal
    return async () => {
      window.removeEventListener('keypress', handleKeyPress);
    };
  }, [scannerModal]);

  useEffect(() => {
    window.setPageTitle("Adicionar Rota");
    if (loadingSro) {
      searchShippingSro()
    }
  }, [loadingSro])

  return (
    <>
      <ReactModal
        isOpen={scannerModal}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => {
          setScannerModal(false)
          setShippingCodeData(() => ({
            error: "",
            isOK: 'vazio',
            code: ""
          }));
          setSroOk("vazio")
          setTypeModal()
        }}
        style={stylesModal22}
        shouldCloseOnEsc
        showCancelButton={true}
      >
        <div className={styles.modalBody2}>
          <div>
            <h6>Escanear etiqueta</h6>
            <p>Por favor, mantenha o bip continuamente apontado para a etiqueta</p>
            <div className={styles.imgBarcode} role={sroOk}>
              <img
                src={barCodeScanner}
                alt="barcode scanner"
              />
            </div>
          </div>
          <div className={styles.input} role={sroOk}>
            <input
              type="text"
              name={"code"}
              ref={inputRef}
              style={{ display: "none" }}
            />
            {shippingCodeData.code && (
              <div className={styles.tracking}>
                <img
                  src={`data:image/jpeg;base64,${barcodeImage}`}
                  alt="Código de Barras"
                />
                <span>{shippingCodeData.code}</span>
              </div>
            )}
          </div>
          {shippingCodeData.isOK === "notOk" && (
            <p className={styles.error}>{shippingCodeData.error}</p>
          )}
        </div>
      </ReactModal>

      <ReactModal
        isOpen={digitCodeModal}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => {
          setDigitCodeModal(false);
          setShippingCodeData((prevData) => ({
            ...prevData,
            error: "",
            isOK: 'vazio',
            code: ""
          }));
          setTypeModal()
        }}
        shouldCloseOnEsc
        showCancelButton={true}
        style={stylesModal22}
      >
        <div className={styles.modalBody}>
          <h6>Digitar código manualmente</h6>
          <span>
            Preencha o campo abaixo com o código <br />
            do pacote (ou da coleta) que deseja adicionar
          </span>
          <div className={styles.input}>
            <input
              placeholder="Digite o código aqui"
              type="text"
              onChange={handleInputCode}
              value={shippingCodeData.code}
              name={"code"}
            />
          </div>
          {shippingCodeData.isOK === "notOk" && (
            <p className={styles.error}>{shippingCodeData.error}</p>
          )}

          <div className={styles.buttonContainerModal}>
            <button
              onClick={() => {
                setAddPackageModal(true)
                setDigitCodeModal(false);
                setShippingCodeData((prevData) => ({
                  ...prevData,
                  error: "",
                  isOK: 'vazio',
                  code: ""
                }));
              }}
            >
              Voltar
            </button>
            <button onClick={searchShippingSro}>Confirmar</button>
          </div>
        </div>
      </ReactModal>

      <ReactModal
        isOpen={addPackageModal}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => setAddPackageModal(false)}
        style={stylesModal22}
      >
        <div className={styles.modalBody}>
          <h6>Adicionar pacotes</h6>
          <span>Selecione uma das opções abaixo para prosseguir:</span>
          <div className={styles.buttonContainerAddPackageModal}>
            <button
              className={styles.scanner}
              onClick={() => {
                setAddPackageModal(false);
                setScannerModal(true);
                setTypeModal(modalTypes.scanner)
              }}
            >
              <BiBarcodeReader color="#fff" size={24} />
              Escanear a etiqueta do pacote
            </button>
          </div>
          <div className={styles.buttonContainerAddPackageModal}>
            <button
              className={styles.digitCode}
              onClick={() => {
                setAddPackageModal(false);
                setTypeModal(modalTypes.manual)
                setDigitCodeModal(true);
              }}
            >
              <PiListNumbersFill color="#fff" size={20} />
              Digitar código do pacote manualmente
            </button>
          </div>
        </div>
      </ReactModal>
    </>
  )
}
